import { TransactionType } from 'src/types/transaction-type.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { RulePromptState } from 'src/components/atomic/molecules/rulePrompt/RulePrompt';
import { UserAttributes } from 'src/types/user-attributes.enum';

export function getTransactionTypeText(transactionType: TransactionType): string {
    switch (transactionType) {
        case TransactionType.TRANSACTION_INCOME:
            return LiteralsService.getLiteral('TransactionsTable.type.income');
        case TransactionType.TRANSACTION_INTERNAL_TRANSFER:
            return LiteralsService.getLiteral('TransactionsTable.type.transfer');
        default:
            return LiteralsService.getLiteral('TransactionsTable.type.expense');
    }
}

export function shouldShowRulePromptForTransactionTable(
    transactionRulePromptId: number,
    transactionId: number,
    userAttributes: { [key: string]: any },
    rulePromptState: RulePromptState
): boolean {
    return (
        transactionRulePromptId === transactionId &&
        (userAttributes?.[UserAttributes.NEVER_SHOW_CREATE_RULE_PROMPT] !== true ||
            rulePromptState === RulePromptState.NEVER_ASK)
    );
}

export function shouldShowRulePromptForTransactionDetails(
    rulePromptState: RulePromptState,
    userAttributes: { [key: string]: any }
): boolean {
    return (
        rulePromptState != null &&
        (userAttributes?.neverShowCreateRulePrompt !== true || rulePromptState === RulePromptState.NEVER_ASK)
    );
}
